const DiamondIcon: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2482_2120)">
        <path
          d="M16.7497 3.125H5.35571C5.09304 3.13227 4.83574 3.2017 4.60463 3.32767C4.37352 3.45365 4.1751 3.63264 4.02538 3.85017L1.17691 7.82287C0.965395 8.12393 0.859763 8.48753 0.876776 8.85595C0.893788 9.22438 1.03247 9.57652 1.27081 9.85651L9.81624 19.7724C9.96255 19.9624 10.15 20.1161 10.3643 20.2217C10.5786 20.3275 10.8141 20.3824 11.0527 20.3824C11.2913 20.3824 11.5268 20.3275 11.741 20.2217C11.9553 20.1161 12.1428 19.9624 12.2891 19.7724L20.8345 9.85651C21.0728 9.57652 21.2116 9.22438 21.2286 8.85595C21.2455 8.48753 21.14 8.12393 20.9285 7.82287L18.08 3.85017C17.9303 3.63264 17.7319 3.45365 17.5008 3.32767C17.2697 3.2017 17.0123 3.13227 16.7497 3.125Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2385 3.10938L6.41797 9.06842L11.0527 20.3401"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9139 3.10938L15.7188 9.06842L11.0527 20.3401"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.90625 9.07031H21.1989"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      {/* <defs>
        <clipPath id="clip0_2482_2120">
          <rect
            width="21.9211"
            height="22.0705"
            fill="currentColor"
            transform="translate(0 0.460938)"
          />
        </clipPath>
      </defs> */}
    </svg>
  );
};

export default DiamondIcon;
